module.exports = "https://sf6-scmcdn2-tos.pstatp.com/motor/pc/_next/static/images/7-active-ee2f747e38ce083c9e6b6f154716233e.png";